const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '《秘密教学》—— 韩漫人气榜首',
    desc: '年度最受瞩目的韩漫下拉式作品，细腻画风搭配扣人心弦的剧情，每话更新都引发读者热议。沉浸式下拉阅读体验，让你一口气追到最新话。',
    tag: '韩漫精选',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20featuring%20two%20characters%20in%20a%20romantic%20dramatic%20scene%2C%20soft%20warm%20lighting%2C%20delicate%20lineart%2C%20emotional%20expressions%2C%20cream%20and%20coral%20color%20palette%2C%20modern%20digital%20art%2C%20clean%20composition%2C%20professional%20webtoon%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
    color: 'from-accent-500/90 to-primary-500/80',
  },
  {
    id: 2,
    title: '《咒术回战》—— 热血日漫连载中',
    desc: 'Jump系超人气作品，咒术师与咒灵之间的激烈对决。下拉式阅读完美适配快节奏战斗分镜，每一格都张力十足，带给读者影院级视觉冲击。',
    tag: '日漫热载',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20scene%20with%20energy%20effects%20and%20fighting%20poses%2C%20dark%20and%20warm%20tone%20contrast%2C%20Japanese%20shonen%20style%2C%20dramatic%20composition%2C%20speed%20lines%2C%20professional%20manga%20art%2C%20clean%20cream%20background%2C%20high%20contrast&width=800&height=500&seq=carousel-02&orientation=landscape',
    color: 'from-foreground-900/80 to-foreground-700/70',
  },
  {
    id: 3,
    title: '《我独自升级》—— 逆袭爽漫必看',
    desc: '从最弱猎人到世界最强，全程高能无尿点。下拉式浏览完美呈现战斗场面的磅礴气势，每一滑都是视觉盛宴，是无数读者心中的韩漫天花板。',
    tag: '热门推荐',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20warrior%20character%20with%20glowing%20aura%20in%20a%20dungeon%20setting%2C%20Korean%20manhwa%20art%20style%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20shadow%20contrast%2C%20powerful%20stance%2C%20detailed%20armor%2C%20professional%20digital%20illustration%2C%20clean%20background&width=800&height=500&seq=carousel-03&orientation=landscape',
    color: 'from-primary-500/90 to-secondary-500/80',
  },
  {
    id: 4,
    title: '《间谍过家家》—— 欢乐日常治愈系',
    desc: '伪装家庭爆笑日常，间谍×杀手×超能力少女的奇妙组合。下拉式漫画的轻松阅读体验与作品的温馨氛围完美契合，适合随时随地轻松追。',
    tag: '治愈佳作',
    img: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20family%20scene%20in%20anime%20manga%20style%2C%20three%20characters%20smiling%20together%20in%20a%20cozy%20living%20room%2C%20soft%20warm%20lighting%2C%20playful%20expressions%2C%20cream%20and%20coral%20color%20scheme%2C%20clean%20modern%20illustration%2C%20wholesome%20vibe%2C%20professional%20digital%20art&width=800&height=500&seq=carousel-04&orientation=landscape',
    color: 'from-secondary-500/90 to-accent-500/80',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            精选推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门漫画精选</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">下拉式漫画人气作品，每一部都值得从头追到尾</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item) => (
            <article key={item.id} className="group relative rounded-2xl overflow-hidden bg-background-50 cursor-pointer">
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${item.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-800">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}